export default __webpack_public_path__ + "static/09.01-6ed7f35dbf708219b9f4003ab1cf3932.png";